module.exports = __webpack_public_path__ + "img/bm_act.64167a83.svg";